<i18n>
  {
  "no": {
    "nationalIdentityNumber": "Fødselsnummer",
    "willSendNotification": "Vi vil sende en SMS til mobilnummeret tilknyttet fødselsnummeret",
    "11digitNumber": "11-sifret tall",
    "why": "Hvorfor?"
  },
  "en": {
    "nationalIdentityNumber": "National ID Number",
    "willSendNotification": "We will send an SMS to the phone number linked to the national ID number",
    "11digitNumber": "11-digit number",
    "why": "Why?"
  }
  }
</i18n>

<template>
  <div>
    <div class="margin-bottom-2xs label-row">
      <TnLabel :text="t('nationalIdentityNumber')" for-input="txtNationalIdentityNumber" />
      <TnLink size="s" :to="{ name: 'ibis-national-id-info' }" :text="t('why')" />
    </div>

    <TnTextField
      id="txtNationalIdentityNumber"
      v-model="nationalIdentityNumber"
      name="nationalIdentityNumber"
      type="text"
      inputmode="numeric"
      autocomplete="off"
      required
      :placeholder="t('11digitNumber')"
      :description="t('willSendNotification')"
      :error="showError ? t('11digitNumber') : undefined"
      @blur="touched = true"
    />

    <input type="hidden" name="msisdn" :value="signUpRequest.msisdn" />
    <input type="hidden" name="signUpId" :value="signUpRequest.signUpId" />
    <input type="hidden" name="firstAndMiddleName" :value="signUpRequest.firstAndMiddleName" />
    <input type="hidden" name="lastName" :value="signUpRequest.lastName" />
  </div>
</template>

<script setup lang="ts">
import { computed, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { TnLabel, TnLink, TnTextField } from '@telenornorgeinternal/telegrafen-vue3-core';

import type { SignUpRequestFormFields } from '@/types';

const props = defineProps<{ signUpRequest: SignUpRequestFormFields }>();
// Replaces the Vue 2 `:form-valid.sync` / $emit('update:formValid') pattern.
const formValid = defineModel<boolean>('formValid', { default: false });

const { t } = useI18n();

const nationalIdentityNumber = ref<string>(props.signUpRequest.nationalIdentityNumber ?? '');
const touched = ref(false);

const isValid = computed(() => {
  if (!nationalIdentityNumber.value && props.signUpRequest.canCancelSignUp) return true;
  return /^\d{11}$/.test(nationalIdentityNumber.value);
});

const showError = computed(
  () => touched.value && !props.signUpRequest.canCancelSignUp && !isValid.value,
);

watch(isValid, (valid) => (formValid.value = valid), { immediate: true });
</script>

<style scoped>
.label-row {
  display: flex;
  align-items: baseline;
  justify-content: space-between;
}
</style>
